export const requiresAaOnboardingTemplates = {
  ENTERPRISE: 'enterprise',
  INACTIVE: 'inactive',
  DOMAIN_CLAIM: 'domainClaim',
  NEWLY_MANAGED: 'newlyManaged',
};
